export function scrollElementIntoContainer(
  container: HTMLElement | null,
  element: HTMLElement | null,
) {
  if (!element) return;

  if (!container || container.clientHeight <= 0) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const scrollOffset =
    elementRect.top -
    containerRect.top -
    (container.clientHeight - elementRect.height) / 2;
  const maxScrollTop = Math.max(
    container.scrollHeight - container.clientHeight,
    0,
  );
  const nextScrollTop = Math.min(
    Math.max(container.scrollTop + scrollOffset, 0),
    maxScrollTop,
  );

  container.scrollTo({
    top: nextScrollTop,
    behavior: "smooth",
  });
}
